import type { Level } from "./types";

/** Map units per league (the in-game distance unit shown to the player). */
export const LEAGUE = 10;

/** All maps share the same sea chart proportions (the SVG viewBox). */
export const MAP_W = 1000;
export const MAP_H = 620;

/**
 * The five voyages, ramping from 5 to 18 ports. Each is drawn on the
 * 1000×620 chart; index 0 of `points` is always the home harbor. `opt` is
 * the **proven** shortest closed-tour length in map units — established by
 * the exact Held–Karp dynamic program (cross-checked against exhaustive
 * search and a HiGHS MILP in `levels.test.ts`) and re-proven live in the
 * browser at reveal time.
 *
 * Difficulty design (greedy = nearest-neighbour from the harbor): greedy
 * sails 0 / 7.4 / 12.6 / 18.7 / 22.4% too far on voyages 1–5 — the maps get
 * less forgiving exactly as the route count explodes. The finale's 18 ports
 * allow 18!/2 ≈ 3.2·10¹⁵ distinct rounds; matching the proven optimum there
 * is meant to feel impossible by hand. That's the lesson.
 */
export const LEVELS: Level[] = [
  {
    name: "The First Crossing",
    points: [[140, 330], [340, 130], [660, 95], [880, 280], [700, 520], [360, 545]],
    opt: 1840.7263785472,
  },
  {
    name: "The Pearl Shallows",
    points: [[169, 224], [416, 405], [401, 223], [874, 513], [236, 480], [786, 314], [628, 378], [311, 298], [529, 470]],
    opt: 1877.8613688009,
  },
  {
    name: "The Scattered Cays",
    points: [[632, 490], [554, 298], [718, 316], [841, 431], [888, 248], [451, 192], [490, 372], [256, 86], [209, 480], [89, 158], [913, 365], [577, 174]],
    opt: 2269.0676668877,
  },
  {
    name: "The Merchant's Gauntlet",
    points: [[700, 406], [917, 217], [552, 401], [205, 377], [728, 199], [281, 85], [812, 383], [599, 496], [105, 469], [356, 259], [162, 238], [436, 172], [323, 493], [657, 71], [814, 515]],
    opt: 2555.6293187786,
  },
  {
    name: "The Eighteen Lanterns",
    points: [[909, 263], [145, 84], [642, 231], [881, 92], [789, 312], [268, 187], [167, 434], [853, 436], [724, 462], [569, 167], [510, 441], [86, 495], [488, 70], [191, 292], [560, 347], [282, 383], [325, 96], [88, 365], [467, 196]],
    opt: 2842.9720816353,
  },
];
